import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92b32930"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "picker-header" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "picker-content"
}
const _hoisted_4 = { class: "categories" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "keyboard_arrow_right", -1))
const _hoisted_7 = {
  key: 0,
  class: "items"
}
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_tooltip = _resolveComponent("md-tooltip")!
  const _component_md_input_field = _resolveComponent("md-input-field")!
  const _component_md_card = _resolveComponent("md-card")!

  return (_openBlock(), _createBlock(_component_md_card, {
    variant: "filled",
    class: "uni-picker",
    style: _normalizeStyle({ top: _ctx.posY + 'px', left: _ctx.posX + 'px' })
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.typeName) + " auswählen", 1),
          _createVNode(_component_md_tooltip, {
            position: "left",
            text: "Schließen"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_md_button, {
                variant: "icon",
                icon: "close",
                grey: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_md_input_field, {
          label: "Suchbegriff",
          error: false,
          size: "small",
          "trailing-icon": "search"
        })
      ]),
      (_ctx.data)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (category, k) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: k,
                  class: _normalizeClass({ selected: _ctx.selectedCategory == k }),
                  onClick: ($event: any) => (_ctx.switchCategory(k))
                }, [
                  _createElementVNode("span", null, _toDisplayString(category.label), 1),
                  _hoisted_6
                ], 10, _hoisted_5))
              }), 128))
            ]),
            (_ctx.selectedCategory)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data[_ctx.selectedCategory].items, (item, k) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: k,
                      class: _normalizeClass({ selected: _ctx.selectedItem == item.value }),
                      onClick: ($event: any) => (_ctx.selectItem(item.value))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(item.label), 1)
                    ], 10, _hoisted_8))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["style"]))
}